/* eslint-disable @next/next/no-img-element */
"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import AngleRightBold from "@/icons/angleRightBold.svg";
import Quote from "@/icons/quote.svg";

import "swiper/css";
import "swiper/css/navigation";
import { getTranslation } from "@/i18n/get-translation";

interface ITestimonials {
  locale: string;
}
export default function Testimonials({ locale }: ITestimonials) {
  const t = getTranslation(locale, "testimonials");
  return (
    <section className="lg:my-36 my-24 py-0 xl:pl-16 lg:pl-12 pl-0 lg:bg-primary-500 bg-transparent relative">
      <div className="max-w-[120rem] mx-auto flex justify-between lg:items-center lg:pr-0 lg:flex-row flex-col lg:max-h-[30rem] max-h-none">
        <div className="block lg:flex-[1_1_50%] flex-[1_1_100%] lg:max-w-[50%] max-w-[100%]">
          <img
            loading="lazy"
            src="/images/testimonial-photo.webp"
            alt="Creating Impact"
            className="w-full max-w-full lg:px-0 px-7"
          />
        </div>
        <div className="block lg:flex-[1_1_50%] flex-[1_1_100%] lg:max-w-[50%] max-w-[100%] overflow-hidden px-7 lg:pr-0">
          <div className="mt-16 relative w-full">
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={56}
              slidesPerView={1}
              pagination={true}
              navigation={{
                nextEl: ".next-slide",
                prevEl: ".prev-slide",
              }}
              breakpoints={{
                1299: {
                  slidesPerView: 2,
                  spaceBetween: 26,
                },
                1060: {
                  slidesPerView: 1,
                  spaceBetween: 15,
                },
                992: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                  pagination: false,
                },
              }}
              className="relative !pb-10 !overflow-visible quotes"
            >
              <SwiperSlide>
                <article className="text-left">
                  <figure className="mb-3 bg-primary-400-25 rounded-full w-10 h-10 flex items-center justify-center text-primary-800">
                    <Quote className="w-5" />
                  </figure>
                  <p className="text-primary-800 text-xl font-light pr-4">
                    “As a healthcare professional, I have had the privilege of
                    using this software extensively, and it has truly change the
                    way I manage patient care and medical records.”
                  </p>
                  <cite className="flex items-center mt-7 not-italic">
                    <figure className="shadow-100 rounded-full overflow-hidden border-[0.313rem] border-primary-400 flex-[0_0_auto] w-20 h-20">
                      <img
                        loading="lazy"
                        className="w-full h-full object-cover"
                        src="/images/d1.webp"
                        alt=""
                      />
                    </figure>
                    <div className="flex-[1_1_auto] ml-4">
                      <div className="text-secondary-800 text-xl">
                        Dr. Alex Martin
                      </div>
                      <div className="text-primary-700 text-base">
                        General Physician
                      </div>
                    </div>
                  </cite>
                </article>
              </SwiperSlide>
              <SwiperSlide>
                <article className="text-left">
                  <figure className="mb-3 bg-primary-400-25 rounded-full w-10 h-10 flex items-center justify-center text-primary-800">
                    <Quote className="w-5" />
                  </figure>
                  <p className="text-primary-800 text-xl font-light pr-4">
                    “As a healthcare professional, I have had the privilege of
                    using this software extensively, and it has truly change the
                    way I manage patient care and medical records.”
                  </p>
                  <cite className="flex items-center mt-7 not-italic ">
                    <figure className="shadow-100 rounded-full overflow-hidden border-[0.313rem] border-primary-400 flex-[0_0_auto] w-20 h-20">
                      <img
                        loading="lazy"
                        className="w-full h-full object-cover"
                        src="/images/d1.webp"
                        alt=""
                      />
                    </figure>
                    <div className="flex-[1_1_auto] ml-4">
                      <div className="text-secondary-800 text-xl">
                        Dr. Alex Martin
                      </div>
                      <div className="text-primary-700 text-base">
                        General Physician
                      </div>
                    </div>
                  </cite>
                </article>
              </SwiperSlide>
              <SwiperSlide>
                <article className="text-left">
                  <figure className="mb-3 bg-primary-400-25 rounded-full w-10 h-10 flex items-center justify-center text-primary-800">
                    <Quote className="w-5" />
                  </figure>
                  <p className="text-primary-800 text-xl font-light pr-4">
                    “As a healthcare professional, I have had the privilege of
                    using this software extensively, and it has truly change the
                    way I manage patient care and medical records.”
                  </p>
                  <cite className="flex items-center mt-7 not-italic ">
                    <figure className="shadow-100 rounded-full overflow-hidden border-[0.313rem] border-primary-400 flex-[0_0_auto] w-20 h-20">
                      <img
                        loading="lazy"
                        className="w-full h-full object-cover"
                        src="/images/d1.webp"
                        alt=""
                      />
                    </figure>
                    <div className="flex-[1_1_auto] ml-4">
                      <div className="text-secondary-800 text-xl">
                        Dr. Alex Martin
                      </div>
                      <div className="text-primary-700 text-base">
                        General Physician
                      </div>
                    </div>
                  </cite>
                </article>
              </SwiperSlide>
              <SwiperSlide>
                <article className="text-left">
                  <figure className="mb-3 bg-primary-400-25 rounded-full w-10 h-10 flex items-center justify-center text-primary-800">
                    <Quote className="w-5" />
                  </figure>
                  <p className="text-primary-800 text-xl font-light pr-4">
                    “As a healthcare professional, I have had the privilege of
                    using this software extensively, and it has truly change the
                    way I manage patient care and medical records.”
                  </p>
                  <cite className="flex items-center mt-7 not-italic ">
                    <figure className="shadow-100 rounded-full overflow-hidden border-[0.313rem] border-primary-400 flex-[0_0_auto] w-20 h-20">
                      <img
                        loading="lazy"
                        className="w-full h-full object-cover"
                        src="/images/d1.webp"
                        alt=""
                      />
                    </figure>
                    <div className="flex-[1_1_auto] ml-4">
                      <div className="text-secondary-800 text-xl">
                        Dr. Alex Martin
                      </div>
                      <div className="text-primary-700 text-base">
                        General Physician
                      </div>
                    </div>
                  </cite>
                </article>
              </SwiperSlide>
              <div className="absolute z-10 right-0 top-0 bg-slider-gradient h-full w-52 max-md:hidden"></div>
              <button className="prev-slide absolute top-2/4 -translate-y-2/4 z-20 [&.swiper-button-disabled]:opacity-0 left-[6.375rem] max-md:hidden">
                <div className="relative">
                  <div className="bg-primary-500 rounded-full w-14 h-14 drop-shadow-[0px_14px_50px_#BE57DD]"></div>
                  <AngleRightBold className="h-[1.375rem] absolute left-2/4 top-2/4 -translate-1/2 rotate-180" />
                </div>
              </button>
              <button className="next-slide absolute top-2/4 -translate-y-2/4 z-20 [&.swiper-button-disabled]:opacity-0 right-[6.375rem] max-md:hidden">
                <div className="relative">
                  <div className="bg-primary-500 rounded-full w-14 h-14 drop-shadow-[0px_14px_50px_#BE57DD]"></div>
                  <AngleRightBold className="h-[1.375rem] absolute left-2/4 top-2/4 transform-[translate(-50%,-50%)]" />
                </div>
              </button>
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
}
